//
import AssetDiscountTypeModel from '@/models/HumanResource/HrAssetDiscountType'

// hr_asset_discount_type_id, name
export default [
    {
        name: 'hr_asset_discount_type_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'type',
            itemValue: 'id',
            label: 'Tipo',
            model: AssetDiscountTypeModel,
            noObject: true,
            paramSearch: 'type',
        },
    },
    {
        name: 'name',
        type: 'text-field',
        props: {
            label: 'Nombre',
        },
    },
]